import React, { useLayoutEffect, useRef } from "react";
import IMask from "imask";

import Input, { InputProps } from "./Input";

export const MaskedInput: React.FC<InputProps & { mask: string }> = ({ mask, ...props }) => {
  const phoneInputRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    let iMask: IMask.InputMask<IMask.AnyMaskedOptions>;

    if (phoneInputRef.current) {
      iMask = IMask(phoneInputRef.current, {
        mask,
      });
    }

    return () => {
      iMask && iMask.destroy();
    };
  }, [mask]);

  return <Input inputRef={phoneInputRef} {...props} />;
};

export default MaskedInput;
